import {useState, Fragment, useEffect} from 'react'
import Flatpickr from 'react-flatpickr'
import {useSelector, useDispatch} from 'react-redux'
import {
    ChevronDown,
    Search,
    RefreshCcw
} from 'react-feather'
import {
    getSubscriptionReportingData,
    getSearchSubscriptionReports
} from '@src/views/tables/data-tables-admin-subscription-reports/store/actions'
import {getPlansData}
    from '@src/views/tables/data-tables-admin-cancelled-subscription-reports/store/actions/index'
import DataTable from 'react-data-table-component'
import {
    Card,
    CardHeader,
    CardBody,
    CardTitle,
    Input,
    Label,
    FormGroup,
    Row,
    Col,
    Button,
    Spinner
} from 'reactstrap'
import '@styles/react/libs/flatpickr/flatpickr.scss'
import CustomPagination from '@src/views/components/pagination/CustomPagination'
import {Link} from "react-router-dom"

const SubscriptionReport = () => {
    const [Picker, setPicker] = useState('')
    const [searchName, setSearchName] = useState('')
    const [searchPlanId, setSearchPlanId] = useState('')
    const [currentPage, setCurrentPage] = useState(0)
    const [searchEmail, setSearchEmail] = useState('')
    const [filteredData, setFilteredData] = useState([])
    const [paginationInfo, setPaginationInfo] = useState(null)
    const [isTableLoading, setIsTableLoading] = useState(false)
    const [advSearchColumns, setAdvSearchColumns] = useState([
        {
            name: 'company',
            selector: 'company',
            sortable: true,
            minWidth: '200px',
            cell: row => <Link to={`/admin/manage-brands/${row.id}`} className='company-link'>{row.company}</Link>
        },
        {
            name: 'contact name',
            selector: 'contact_name',
            sortable: true,
            minWidth: '200px'
        },
        {
            name: 'purchased date',
            selector: 'purchased_date',
            sortable: true,
            minWidth: '150px'
        },
        {
            name: 'subscription plan',
            selector: 'subscription_plan',
            sortable: true,
            minWidth: '150px'
        },
        {
            name: 'subscription type',
            selector: 'subscription_type',
            sortable: true,
            minWidth: '150px'
        },
        {
            name: 'expire date',
            selector: 'expiry_date',
            sortable: true,
            minWidth: '150px'
        },
        {
            name: 'Status',
            selector: 'status',
            sortable: true,
            minWidth: '70px'
        },
        {
            name: 'Total paid',
            selector: 'total_paid',
            sortable: true,
            minWidth: '100px',
            cell: row => <span>${row.total_paid}</span>
        }
    ])

    const subscriptionReportsSelector = useSelector(store => store.adminSubscriptionReport)
    const cancelledSubscriptionReports = useSelector(store => store.adminCancellSubscriptionsReport)
    const dispatch = useDispatch()

    useEffect(() => {
        if (!!subscriptionReportsSelector?.subscriptionReports) {
            const {links, meta, pages} = subscriptionReportsSelector.subscriptionReports
            setPaginationInfo({...links, ...meta, pages})
            setIsTableLoading(false)
        }
    }, [subscriptionReportsSelector, cancelledSubscriptionReports])

    useEffect(() => {
        setIsTableLoading(true)
        dispatch(getSubscriptionReportingData())
        dispatch(getPlansData())
    }, [])

    const dataToRender = () => {
        if (subscriptionReportsSelector?.subscriptionReports) {
            return subscriptionReportsSelector?.subscriptionReports?.data
        }
    }

    const makeDate = (range) => {
        const arr = []
        range.map(i => {
            const date = new Date(i)

            const year = date.getFullYear()
            let month = (1 + date.getMonth()).toString()
            month = month.length > 1 ? month : `${month}`
            let day = date.getDate().toString()
            day = day.length > 1 ? day : `${day}`
            arr.push(`${month}-${day}-${year}`)
            return true
        })
        setPicker(arr)
    }

    const searchSubscriptionReports = () => {
        setIsTableLoading(true)
        dispatch(getSearchSubscriptionReports(false, {
            brand_name: searchName,
            owner_name: searchEmail,
            plan_id: searchPlanId,
            purchase_from: Picker ? Picker[0] : '',
            purchase_to: Picker ? Picker[1] : ''
        }))
    }

    const refreshSearchForm = () => {
        setSearchName('')
        setSearchEmail('')
        setSearchPlanId('')
        setPicker('')
        setIsTableLoading(true)
        dispatch(getSubscriptionReportingData())
    }

    const handleCustomPagination = pageUrl => {
        setIsTableLoading(true)
        dispatch(getSearchSubscriptionReports(true, {
            brand_name: searchName,
            owner_name: searchEmail,
            plan_id: searchPlanId,
            purchase_from: Picker ? Picker[0] : '',
            purchase_to: Picker ? Picker[1] : ''
        }, pageUrl))
    }
    return (
        <Fragment>
            <Card className="brands-my-campaign-table-parent">
                <CardHeader className='border-bottom'>
                    <CardTitle tag='h4'>Subscription Report</CardTitle>
                    <div className='d-flex mt-md-0 mt-1'>
                        <h4 className="my-0">Earned Subscription:<b className="ml-1 text-primary">${subscriptionReportsSelector?.subscriptionReports?.total_earn || 0}</b></h4>
                    </div>
                </CardHeader>
                <CardBody>
                    <Row form className='mt-1 mb-50'>
                        <Col lg='3' md='4'>
                            <FormGroup>
                                <Label for='name'>Company Name</Label>
                                <Input id='name' placeholder='Company Name' value={searchName}
                                       onChange={(e) => setSearchName(e.target.value)}
                                />
                            </FormGroup>
                        </Col>
                        <Col lg='3' md='4'>
                            <FormGroup>
                                <Label for='email'>Brand Owner Name</Label>
                                <Input
                                    type='email'
                                    id='email'
                                    placeholder='Brand Owner Name'
                                    value={searchEmail}
                                    onChange={(e) => setSearchEmail(e.target.value)}
                                />
                            </FormGroup>
                        </Col>
                        <Col lg='3' md='4'>
                            <FormGroup>
                                <Label for='state'>Subscription Plan</Label>
                                <Input type="select" id='state' placeholder='Subscription Plan' value={searchPlanId} onChange={(e) => setSearchPlanId(e.target.value)}>
                                    <option value=''>Subscription Plan</option>
                                    {cancelledSubscriptionReports.plansListings && cancelledSubscriptionReports.plansListings.map(plans => (
                                        <option value={plans.id}>{plans.label}</option>
                                    ))}
                                </Input>
                            </FormGroup>
                        </Col>
                        <Col lg='3' md='4'>
                            <FormGroup>
                                <Label for='date'>Date:</Label>
                                <Flatpickr
                                    className='form-control'
                                    id='date'
                                    placeholder='Date'
                                    value={Picker}
                                    options={{mode: 'range', dateFormat: 'm/d/Y'}}
                                    onChange={date => makeDate(date)}
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <div className="admin-filter-actions ml-auto text-right">
                                <Button.Ripple className='btn-icon mr-10px' color='primary' onClick={searchSubscriptionReports}>
                                    <Search size={16}/>
                                </Button.Ripple>
                                <Button.Ripple className='btn-icon' outline color='primary' onClick={refreshSearchForm}>
                                    <RefreshCcw size={16}/>
                                </Button.Ripple>
                            </div>
                        </Col>
                    </Row>
                </CardBody>
                {isTableLoading && (<div className="w-100 my-4 text-center"><Spinner color='primary'/></div>)}
                {!isTableLoading && (
                    <>
                        <DataTable
                            noHeader
                            paginationServer
                            columns={advSearchColumns}
                            paginationPerPage={7}
                            className='react-dataTable'
                            sortIcon={<ChevronDown size={10}/>}
                            paginationDefaultPage={currentPage + 1}
                            data={dataToRender()}
                        />
                        <CustomPagination pageLinks={paginationInfo?.pages} onPaginationClick={handleCustomPagination}/>
                    </>
                )}
            </Card>
        </Fragment>
    )
}

export default SubscriptionReport
